export const isLiteApp = import.meta.env.REACT_APP_LITE === "1";

export const signInUrl = import.meta.env.REACT_APP_SIGN_IN_URL;

export const sfwUrl = import.meta.env.REACT_APP_SFW_URL ?? "/";

export const studioHost = import.meta.env.REACT_APP_STUDIO_HOST;
